var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8957 6.00002C10.8968 6.70848 10.7579 7.41017 10.4871 8.06484C10.2164 8.71951 9.81898 9.31428 9.31781 9.81502C8.81648 10.3164 8.22126 10.7141 7.56616 10.9854C6.91106 11.2566 6.20893 11.3961 5.4999 11.3959C4.73676 11.3977 3.98201 11.2366 3.28614 10.9234L1.03039 11.257C0.918395 11.2753 0.803623 11.266 0.696049 11.2298C0.588475 11.1937 0.491352 11.1318 0.413115 11.0496C0.334878 10.9674 0.277893 10.8674 0.247111 10.7581C0.216328 10.6489 0.212678 10.5338 0.236478 10.4229L0.549728 8.13444C0.252484 7.4623 0.100611 6.73494 0.104061 6.00002C0.103092 5.29157 0.241976 4.5899 0.51275 3.93524C0.783523 3.28058 1.18086 2.6858 1.68198 2.18502C2.18329 1.6836 2.77851 1.28589 3.43361 1.01464C4.08872 0.743394 4.79086 0.603917 5.4999 0.604187C6.93176 0.604283 8.305 1.17288 9.31781 2.18502C9.81872 2.68596 10.2159 3.28076 10.4867 3.93538C10.7574 4.59001 10.8964 5.29161 10.8957 6.00002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.427a016d599887eea5f1097306c0ae2c.svg";
export { ForwardRef as ReactComponent };